import SalonBusinessCpaTopicPage from "./SalonBusinessCpaTopicPage";

export default function SalonBusinessCpaPersonalTax() {
  return (
    <SalonBusinessCpaTopicPage
      title="Personal tax"
      description="Organize personal tax records for salon owners and independent beauty professionals."
      sections={[
        {
          title: "Income records",
          body: "Prepare slips and business income details.",
          items: ["T4 or T5 slips", "Self-employment income", "Rental or investment slips"],
        },
        {
          title: "Deduction support",
          body: "Collect records that may support personal tax deductions.",
          items: ["Professional expenses", "Vehicle notes", "Home office support"],
        },
        {
          title: "Family details",
          body: "Keep common personal tax items in one place.",
          items: ["Dependants", "Medical receipts", "RRSP and tuition slips"],
        },
      ]}
    />
  );
}
